import { Link } from "react-router-dom";

export const Footer = () => {
  const countries = [
    ["US", "United States"], ["IN", "India"], ["BR", "Brazil"], ["JP", "Japan"],
    ["DE", "Germany"], ["GB", "United Kingdom"], ["FR", "France"], ["KR", "South Korea"],
  ];
  const categories = ["People", "Places", "News", "Tech", "Sports", "Entertainment", "Food", "Brands"];
  return (
    <footer data-testid="site-footer" className="bg-black text-white">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="font-display font-extrabold tracking-tighter text-3xl">UNIVERSTREND</div>
          <p className="mt-3 text-sm text-white/60 max-w-sm">
            An editorial index of the world&apos;s most googled curiosities. Made for people who notice patterns.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <Link to="/sponsor" data-testid="footer-sponsor-cta" className="overline border border-white/40 px-3 py-1.5 hover:bg-white hover:text-black">
              Sponsor →
            </Link>
            <a
              href="mailto:jdemaratte@gmail.com"
              data-testid="footer-contact-email"
              className="overline border border-white/40 px-3 py-1.5 hover:bg-white hover:text-black"
            >
              Contact
            </a>
          </div>
          <p className="mt-4 font-mono text-xs text-white/50">
            <a href="mailto:jdemaratte@gmail.com" className="hover:text-[#ff3b30]">jdemaratte@gmail.com</a>
          </p>
        </div>
        <div>
          <div className="overline text-white/50 mb-3">By country</div>
          <ul className="space-y-1.5 text-sm">
            {countries.map(([code, name]) => (
              <li key={code}>
                <Link to={`/country/${code.toLowerCase()}`} className="hover:text-[#ff3b30]" data-testid={`footer-country-${code}`}>{name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="overline text-white/50 mb-3">By category</div>
          <ul className="space-y-1.5 text-sm">
            {categories.map((c) => (
              <li key={c}>
                <Link to={`/category/${c.toLowerCase()}`} className="hover:text-[#ff3b30]" data-testid={`footer-category-${c}`}>{c}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="overline text-white/50 mb-3">The Site</div>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/about" className="hover:text-[#ff3b30]" data-testid="footer-about">About</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-[#ff3b30]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/sponsor" className="hover:text-[#ff3b30]">Sponsor</Link></li>
            <li><a href="mailto:jdemaratte@gmail.com" className="hover:text-[#ff3b30]">Contact</a></li>
          </ul>
          <div className="mt-6 font-mono text-xs text-white/40 space-y-1">
            <div>Cabinet Grotesk</div>
            <div>& IBM Plex Mono</div>
            <div>© {new Date().getFullYear()} Universtrend</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
